import { createSlice, createSelector } from "@reduxjs/toolkit";
import { coreApi } from "api/core";
import { setShowMessage } from "redux/slices/uiSlice";

const baseUrl = "/supplier-groups";
const initialState = {
  supplierGroups: [],
  supplierGroup: {},
  loading: false,
};

const supplierGroupsSlice = createSlice({
  name: "supplierGroups",
  initialState,
  reducers: {
    setSupplierGroup: (state, action) => {
      state.supplierGroup = action.payload;
    },
    setSupplierGroups: (state, action) => {
      state.supplierGroups = action.payload;
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setReady: (state) => {
      state.loading = false;
    },
    clearSupplierGroups: (state) => {
      state.supplierGroups = [];
      state.supplierGroup = null;
    },
  },
});

export const { setSupplierGroup, setSupplierGroups, setLoading, setReady, clearSupplierGroups } =
  supplierGroupsSlice.actions;
export default supplierGroupsSlice.reducer;
// get all Accounts
export const getAllSupplierGroups = () => async (dispatch) => {
  dispatch(setLoading());

  try {
    const url = baseUrl + `/all`;
    const supplierGroups = await coreApi.fetch(url, "GET");
    dispatch(setSupplierGroups(supplierGroups));
  } catch (err) {
    console.error(err);
    dispatch(
      setShowMessage({
        description: "Failed to fetch accounts",
        type: "error",
      })
    );
  } finally {
    dispatch(setReady());
  }
};
// get Account of logged in user
export const getSupplierGroup = () => async (dispatch) => {
  dispatch(setLoading());

  try {
    const supplierGroup = await coreApi.fetch(baseUrl, "GET");
    dispatch(setSupplierGroup(supplierGroup));
  } catch (err) {
    console.error(err);
    dispatch(
      setShowMessage({
        description: "Failed to fetch Account",
        type: "error",
      })
    );
  } finally {
    dispatch(setReady());
  }
};
// get Account by Id
export const getSupplierGroupById = (id) => async (dispatch) => {
  dispatch(setLoading());

  try {
    const url = baseUrl + `/${id}`;
    const supplierGroup = await coreApi.fetch(url, "GET");
    dispatch(setSupplierGroup(supplierGroup));
  } catch (err) {
    console.error(err);
    dispatch(
      setShowMessage({
        description: "Failed to fetch Account",
        type: "error",
      })
    );
  } finally {
    dispatch(setReady());
  }
};
// add Account
export const addSupplierGroup = (payload) => async (dispatch) => {
  dispatch(setLoading());

  try {
    const res = await coreApi.post(baseUrl, payload);
    dispatch(
      setShowMessage({
        description: "Account created successfully",
        type: "success",
      })
    );
    return res;
  } catch (err) {
    if (err.response?.status === 409) {
      dispatch(
        setShowMessage({
          description: "Account already exists",
          type: "error",
        })
      );
    } else {
      dispatch(
        setShowMessage({
          description: "Failed to create Account",
          type: "error",
        })
      );
    }
  } finally {
    dispatch(setReady());
  }
};
// Update a account
export const updateSupplierGroup = (id, payload) => async (dispatch) => {
  dispatch(setLoading());

  try {
    const url = baseUrl + `/${id}`;
    const res = await coreApi.put(url, payload);
    dispatch(
      setShowMessage({
        description: "account updated successfully",
        type: "success",
      })
    );
    return res;
  } catch (err) {
    if (err.response?.status === 409) {
      dispatch(
        setShowMessage({
          description: "Account already exists",
          type: "error",
        })
      );
    } else {
      dispatch(
        setShowMessage({
          description: "Failed to update Account",
          type: "error",
        })
      );
    }
  } finally {
    dispatch(setReady());
  }
};

// Selectors
const supplierGroupsSelector = ({ supplierGroups }) => supplierGroups?.supplierGroups || [];
const supplierGroupSelector = ({ supplierGroups }) => supplierGroups?.supplierGroup || {};
const supplierGroupsStatusSelector = ({ supplierGroups }) => supplierGroups.loading;

export const selectSupplierGroups = createSelector(supplierGroupsSelector, (supplierGroups) => supplierGroups);
export const selectSupplierGroup = createSelector(supplierGroupSelector, (supplierGroup) => supplierGroup);
export const selectSupplierGroupsStatus = createSelector(supplierGroupsStatusSelector, (loading) => loading);
